import React from 'react';
import Card from 'components/Card';
import CardContent from 'components/CardContent';
import { useTranslation } from 'react-i18next';
import styled from '@emotion/styled/macro';
import { useSelector } from 'react-redux';
import Grid from 'components/Grid';
import { birthdaySelectors } from 'redux/birthday';
import NavLink from 'components/NavLink';
import { getBirthdaysLink } from 'containers/Side/MemberEvents/memberEventsService';
import WidgetData from './WidgetData';
import useWidgetCapDetector from './useWidgetCapDetector';

const StyledCard = styled(Card)`
  overflow: hidden;
`;

const Title = styled('span')`
  font-weight: 600;
  font-size: 1.1rem;
  white-space: nowrap;

  @media(max-width: 360px) { font-size: 1rem; }
  @media(max-width: 325px) { font-size: 0.9rem; }
`;

const BirthdayEventLink = styled(NavLink)`
  color: inherit;
  text-decoration: none;
`;

const BirthdayWidget = (args) => {
  const { t } = useTranslation(['component']);

  const today = useSelector(birthdaySelectors.getBirthdayEventsOverviewToday);
  const upcoming = useSelector(birthdaySelectors.getBirthdayEventsOverviewUpcoming);

  const [wrapperRef, [todayCap, upcomingCap]] = useWidgetCapDetector();

  return (
    <StyledCard {...args} ref={wrapperRef}>
      <BirthdayEventLink to={getBirthdaysLink} replace>
        <CardContent>
          <Grid container direction="column" wrap="nowrap" spacing={1}>
            <Grid item>
              <Title>{t('birthdayWidget.title')} <span role="img" aria-label="emoji">&#x1F389;</span></Title>
            </Grid>
            <Grid item>
              <Grid container direction="row" wrap="nowrap" spacing={2}>
                {today.length > 0 && todayCap > 0 && (
                  <Grid item>
                    <WidgetData title={t('birthdayWidget.today')} users={today} max={todayCap} />
                  </Grid>
                )}
                {upcoming.length > 0 && upcomingCap > 0 && (
                  <Grid item>
                    <WidgetData title={t('birthdayWidget.upcoming')} users={upcoming} max={upcomingCap} />
                  </Grid>
                )}
              </Grid>
            </Grid>
          </Grid>
        </CardContent>
      </BirthdayEventLink>
    </StyledCard>
  );
};

export default BirthdayWidget;
